import React, { Component } from 'react'
import { Row, Col, Spin, Divider, Table, Pagination } from 'antd'
import moment from 'moment'
import _ from 'lodash'

class ListItems extends Component {
  onPageChange = page => {
    this.props.onPageChange(page)
  }

  dateFilter = date => {
    return (date && moment(date).format('YYYY-MM-DD')) || 'Not Entered'
  }

  renderAsigneeSection(job, section) {
    if (!job.items[section] || !job.items[section].length) return null
    const dataSource = job.items[section].map(row => {
      let assigned_to = null
      if (row.assigned_to_id)
        assigned_to = `${row.assigned_to_first_name} ${row.assigned_to_last_name}`
      if (!row.assigned_to_id && row.assigned_to_role_name)
        assigned_to = `(${row.assigned_to_role_name})`
      if (!row.assigned_to_id && !row.assigned_to_role_name) assigned_to = 'n/a'

      return {
        id: row.id,
        type: row.type,
        date: this.dateFilter(row.due_date),
        assigned_to: assigned_to,
        description: row.description
      }
    })

    const columns = [
      {
        title: 'Id',
        dataIndex: 'id'
      },
      {
        title: 'Type',
        dataIndex: 'type'
      },
      {
        title: 'Due Date',
        dataIndex: 'date'
      },
      {
        title: 'Assigned To',
        dataIndex: 'assigned_to'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      }
    ]

    return (
      <Row style={{ marginTop: 10 }}>
        <h6>{_.startCase(section)}</h6>
        <Table
          size="small"
          style={{ backgroundColor: 'white' }}
          pagination={false}
          dataSource={dataSource}
          columns={columns}
        />
      </Row>
    )
  }

  renderPlainSection(job, section) {
    if (!job.items[section] || !job.items[section].length) return null
    const dataSource = job.items[section].map(row => {
      return {
        id: row.id,
        type: row.type,
        date: this.dateFilter(row.due_date),
        description: row.description
      }
    })

    const columns = [
      {
        title: 'Id',
        dataIndex: 'id'
      },
      {
        title: 'Type',
        dataIndex: 'type'
      },
      {
        title: 'Due Date',
        dataIndex: 'date'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      }
    ]

    return (
      <Row style={{ marginTop: 10 }}>
        <h6>{_.startCase(section)}</h6>
        <Table
          size="small"
          style={{ backgroundColor: 'white' }}
          pagination={false}
          dataSource={dataSource}
          columns={columns}
        />
      </Row>
    )
  }

  renderFileSection(job, section) {
    if (!job.items[section] || !job.items[section].length) return null
    const dataSource = []

    job.items[section].forEach(item => {
      item.attachments.forEach(row => {
        dataSource.push({
          id: item.id,
          type: item.type,
          filename: row.filename,
          description: row.description,
          status: row.status,
          updated_date: this.dateFilter(row.updated_date)
        })
      })
    })

    const columns = [
      {
        title: 'Id',
        dataIndex: 'id'
      },
      {
        title: 'Type',
        dataIndex: 'type'
      },
      {
        title: 'Filename',
        dataIndex: 'filename'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Status Date',
        dataIndex: 'updated_date'
      }
    ]

    return (
      <Row style={{ marginTop: 10 }}>
        <h6>{_.startCase(section)}</h6>
        <Table
          size="small"
          style={{ backgroundColor: 'white' }}
          pagination={false}
          dataSource={dataSource}
          columns={columns}
        />
      </Row>
    )
  }

  iterateJobs = () => {
    const { fullReport } = this.props
    return fullReport.map((job, index) => {
      return (
        <Row key={job.id}>
          <Col span={24}>
            <h5>
              {job.id} - {job.name}
            </h5>
            <Row>
              <Row>
                <Col span={12}>
                  <h4 className="ant-list-item-meta-title">Company</h4>
                  <div className="ant-list-item-meta-description">{job.company_name}</div>

                  <h4 className="ant-list-item-meta-title">Assigned To</h4>
                  <div className="ant-list-item-meta-description">
                    {job.assigned_to_first_name} {job.assigned_to_last_name}
                  </div>

                  <h4 className="ant-list-item-meta-title">Executed Contract</h4>
                  <div className="ant-list-item-meta-description">
                    {this.dateFilter(job.schedule_executed_contract_date)}
                  </div>
                </Col>
              </Row>
              {job.type === 'Maintenance/Service' && (
                <Row>
                  <Col span={12}>
                    <h4 className="ant-list-item-meta-title">Contract Expiration</h4>
                    <div className="ant-list-item-meta-description">
                      {this.dateFilter(job.schedule_contract_expiration_date)}
                    </div>
                  </Col>

                  <Col span={12}>
                    <h4 className="ant-list-item-meta-title">CAT 1 Due</h4>
                    <div className="ant-list-item-meta-description">
                      {this.dateFilter(job.schedule_cat1_due_date)}
                    </div>

                    <h4 className="ant-list-item-meta-title">CAT 5 Due</h4>
                    <div className="ant-list-item-meta-description">
                      {this.dateFilter(job.schedule_cat5_due_date)}
                    </div>
                  </Col>
                </Row>
              )}

              <Row>
                <Col span={12}>
                  {job.schedule.manufacturings.map(row => {
                    return (
                      <Row key={row.id}>
                        {job.type !== 'Repair' &&
                          job.type !== 'Maintenance/Service' && (
                            <div>
                              <h4 className="ant-list-item-meta-title">
                                Release for Manufacturing
                              </h4>
                              <div className="ant-list-item-meta-description">
                                {this.dateFilter(row.release_for_manufacturing_date)}
                              </div>
                            </div>
                          )}

                        {job.type !== 'Maintenance/Service' && (
                          <div>
                            <h4 className="ant-list-item-meta-title">Estimated Shipment</h4>
                            <div className="ant-list-item-meta-description">
                              {this.dateFilter(row.estimated_shipment_date)}
                            </div>
                          </div>
                        )}

                        {job.type !== 'Maintenance/Service' && (
                          <div>
                            <h4 className="ant-list-item-meta-title">Estimated Delivery</h4>
                            <div className="ant-list-item-meta-description">
                              {this.dateFilter(row.estimated_delivery_date)}
                            </div>
                          </div>
                        )}
                      </Row>
                    )
                  })}
                </Col>
                {job.type !== 'Repair' &&
                  job.type !== 'Material Sale' &&
                  job.type !== 'Maintenance/Service' && (
                    <Col span={12}>
                      {job.schedule.applications.map(row => (
                        <Row key={row.id}>
                          <div>
                            <h4 className="ant-list-item-meta-title">BEC Permit Expiration</h4>
                            <div className="ant-list-item-meta-description">
                              {this.dateFilter(row.bec_permit_expiration_date)}
                            </div>
                          </div>
                          <div>
                            <h4 className="ant-list-item-meta-title">
                              Elevator Application Expiration
                            </h4>
                            <div className="ant-list-item-meta-description">
                              {this.dateFilter(row.elevator_application_expiration_date)}
                            </div>
                          </div>
                          <div>
                            <h4 className="ant-list-item-meta-title">
                              Temporary Construction Use Inspection Expiration
                            </h4>
                            <div className="ant-list-item-meta-description">
                              {this.dateFilter(
                                row.temporary_construction_use_inspection_expiration_date
                              )}
                            </div>
                          </div>
                        </Row>
                      ))}
                    </Col>
                  )}
              </Row>
            </Row>
            <Row>{this.renderAsigneeSection(job, 'followUps')}</Row>
            <Row>{this.renderFileSection(job, 'drawings')}</Row>
            <Row>{this.renderAsigneeSection(job, 'materialRequests')}</Row>
            <Row>{this.renderPlainSection(job, 'workOrders')}</Row>
            <Row>{this.renderAsigneeSection(job, 'driverRequests')}</Row>
            <Row>{this.renderPlainSection(job, 'serviceOrders')}</Row>
            <Row>{this.renderAsigneeSection(job, 'paymentRequests')}</Row>
            <Row>{this.renderAsigneeSection(job, 'aias')}</Row>
            <Row>{this.renderAsigneeSection(job, 'invoices')}</Row>
            <Row>{this.renderPlainSection(job, 'transmittals')}</Row>
            <Row>{this.renderPlainSection(job, 'rfis')}</Row>
            <Row>{this.renderPlainSection(job, 'violations')}</Row>
            <Row>{this.renderPlainSection(job, 'changeOrders')}</Row>
            <Row>{this.renderPlainSection(job, 'repairOrders')}</Row>
            <Row>{this.renderPlainSection(job, 'changeOrderEstimates')}</Row>
            <Row>{this.renderPlainSection(job, 'repairOrderEstimates')}</Row>
            <Divider />
          </Col>
        </Row>
      )
    })
  }

  render() {
    const { loadingFullReport, fullReport, page, pageCount } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <h4>Jobs</h4>
              {this.iterateJobs(fullReport)}
              <Pagination
                defaultCurrent={page || 1}
                total={pageCount}
                onChange={this.onPageChange}
              />
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/general/job-minutes-report/ListItems.js